import { Col, Row, Dropdown } from 'antd';
import React from 'react';
import { Radio } from '..';
import Menu from './style';

const Index = (props) => {
  const {
    children,
    menus = [],
    width,
    gap,
    ghost,
    labelClassName = 'font-paragraph_medium',
    desClassName = 'font-caption',
    menuItemType,
    selected,
    setSelected,
    max,
    renderItem,
    height,
    hidden,
  } = props;

  const dropdownContent = () => {
    return (
      <Menu
        width={width}
        gap={gap}
        ghost={ghost}
        max={max}
        hidden={hidden}
        height={height}
      >
        {menus?.map((item, index) => {
          const isActive = item?.value === selected?.value;
          const isHasChildren = item?.children;
          if (isHasChildren) {
            return (
              <Row key={item?.value || index} aria-hidden>
                <Col
                  key={item?.value || index}
                  span={24}
                  className="font-paragraph_medium black2"
                  style={{ padding: '8px' }}
                >
                  {item?.label}
                </Col>
                <Col span={24}>
                  {isHasChildren?.map((itemChildren) => {
                    return (
                      <Menu.Item
                        key={itemChildren?.value}
                        onClick={() => {
                          if (item?.onClick) {
                            item?.onClick();
                          }
                          if (setSelected) {
                            setSelected(itemChildren);
                          }
                        }}
                      >
                        <Row
                          key={itemChildren?.value}
                          wrap={false}
                          align="top"
                          gutter={8}
                        >
                          {menuItemType === 'radio' && (
                            <Col>
                              <Radio.Item
                                ghost
                                checked={
                                  itemChildren?.value === selected?.value
                                }
                                radioPadding="0px"
                              />
                            </Col>
                          )}
                          <Col>
                            <Row>
                              <Col span={24} className={labelClassName}>
                                {itemChildren?.label}
                              </Col>
                              {itemChildren?.desc && (
                                <Col
                                  span={24}
                                  className={desClassName}
                                  style={{ whiteSpace: 'normal' }}
                                >
                                  {itemChildren?.desc}
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </Menu.Item>
                    );
                  })}
                </Col>
              </Row>
            );
          }
          return (
            <Menu.Item
              key={item?.value || index}
              onClick={() => {
                if (item?.onClick) {
                  item?.onClick();
                }
                if (setSelected) {
                  setSelected(item);
                }
              }}
            >
              <Row
                wrap="true"
                align="top"
                gutter={8}
                className="component_dropdown_list_item"
              >
                {menuItemType === 'radio' && (
                  <Col>
                    <Radio.Item ghost checked={isActive} radioPadding="0px" />
                  </Col>
                )}
                {renderItem && renderItem(item, isActive)}
                {!renderItem && (
                  <Col>
                    <Row>
                      <Col
                        span={24}
                        className={`component_dropdown_list_item_title ${labelClassName}`}
                      >
                        {item?.label}
                      </Col>
                      {item?.desc && (
                        <Col
                          span={24}
                          className={`component_dropdown_list_item_desc ${desClassName}`}
                        >
                          {item?.desc}
                        </Col>
                      )}
                    </Row>
                  </Col>
                )}
              </Row>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  return (
    <Dropdown overlay={dropdownContent()} trigger={['click']}>
      {children}
    </Dropdown>
  );
};

export default Index;
